export const notReadNumber = state => state.notReadNumber
export const authTree = state => state.authTree


// WEBPACK FOOTER //
// ./src/store/getters.js